import { BrowserModule } from '@angular/platform-browser';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HomeComponent } from './home/home.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { MainSidebarComponent } from './main-sidebar/main-sidebar.component';
 import { OAuthModule as OAuthModuleCodeFlow } from 'angular-oauth2-oidc-codeflow';
import { OAuthModule as OAuthModuleOIDCStandard } from 'angular-oauth2-oidc';
import {MicrosoftGraphService} from './_services/microsoftGraph.service';
import { FormAzureObjectComponent } from './bi/form-azure-object/form-azure-object.component';
import { AdminComponent } from './admin/admin.component';
import {User} from './_models/user.model';
import {ApiClhubService} from './_services/apiClhub.service';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {Select2Module} from 'ng2-select2';
import { ReportViewComponent } from './bi/reports/report-view/report-view.component';
import { DashboardViewComponent } from './bi/dashboards/dashboard-view/dashboard-view.component';
import {ApplicationRef, CUSTOM_ELEMENTS_SCHEMA, DoBootstrap, NO_ERRORS_SCHEMA, NgModule} from '@angular/core';
import { LicenseListComponent } from './capa/license/license-list/license-list.component';
import { LicenseViewComponent } from './capa/license/license-view/license-view.component';
import {ApiCapaService} from './_services/apiCapa.service';
import {DataTablesModule} from 'angular-datatables';
import { ResultListComponent } from './capa/result/result-list/result-list.component';
import { ResultViewComponent } from './capa/result/result-view/result-view.component';
import { LicenseSidebarComponent } from './capa/license/license-sidebar/license-sidebar.component';
import {OwlDateTimeModule, OwlNativeDateTimeModule} from 'ng-pick-datetime';
import {NoopAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import { CapaComponent } from './capa/capa.component';
import { CreateAccountComponent } from './capa/create-account/create-account.component';
import {RendererService} from './_services/renderer.service';
import { AccountManagementSidebarComponent } from './capa/account-management-sidebar/account-management-sidebar.component';
import {AppGlobal} from '../environments/app.global';
import {KeycloakAngularModule, KeycloakService} from 'keycloak-angular';
import {HTTP_INTERCEPTORS, HttpClient, HttpClientModule, HttpHeaders} from '@angular/common/http';
import {environment} from '../environments/environment';
import {map} from 'rxjs/operators';
import {AccessToken} from './_models/access-token.model';
import {AuthenticationService} from './_services/authentication.service';
import {ErrorInterceptor} from './_helpers/error.interceptor';
import {PowerBiObjectListComponent} from './bi/power-bi-object-list/power-bi-object-list.component';
import { CommonModule } from '@angular/common';
import { MainFooterComponent } from './main-footer/main-footer.component';

const keycloakService = new KeycloakService();
const microsoftGraph = new MicrosoftGraphService();

@NgModule({
  declarations: [
    AppComponent,
    HomeComponent,
    MainHeaderComponent,
    MainSidebarComponent,
    MainFooterComponent,
    FormAzureObjectComponent,
    AdminComponent,
    PowerBiObjectListComponent,
    ReportViewComponent,
    DashboardViewComponent,
    LicenseListComponent,
    LicenseViewComponent,
    ResultListComponent,
    ResultViewComponent,
    LicenseSidebarComponent,
    CapaComponent,
    CreateAccountComponent,
    AccountManagementSidebarComponent,
  ],
    imports: [
      BrowserModule,
      AppRoutingModule,
      HttpClientModule,
      OAuthModuleOIDCStandard.forRoot(),
      OAuthModuleCodeFlow.forRoot(),
      ReactiveFormsModule,
      Select2Module,
      DataTablesModule,
      FormsModule,
      OwlDateTimeModule,
      OwlNativeDateTimeModule,
      NoopAnimationsModule,
      NgbModule,
      KeycloakAngularModule,
      // CommonModule // deja importer dans Browser module
    ],
  providers: [
    AppGlobal,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ErrorInterceptor,
      multi: true
    },
    {
      provide: MicrosoftGraphService,
      useValue: microsoftGraph
    },
    RendererService,
    User,
    ApiClhubService,
    ApiCapaService,
    OwlDateTimeModule,
    OwlNativeDateTimeModule,
    {
      provide: KeycloakService,
      useValue: keycloakService
    }
  ],
  // bootstrap: [AppComponent],
  entryComponents: [AppComponent],
  schemas:[
    CUSTOM_ELEMENTS_SCHEMA,
    NO_ERRORS_SCHEMA
  ]
})
export class AppModule implements DoBootstrap {
  constructor(private httpClient: HttpClient, private authenticationService: AuthenticationService) {
  }
  ngDoBootstrap(appRef: ApplicationRef) {
    keycloakService
      .init(
        {
          config: {
            url: environment.keycloakBaseURL,
            realm: environment.keycloakRealm,
            clientId: environment.keycloakClient,
          },
          initOptions: {
            useNonce: true,
            checkLoginIframe: false,
            enableLogging: true,
            onLoad: 'check-sso',
            // responseMode: 'query',

            redirectUri: window.location.origin + window.location.pathname,
            promiseType: 'native'
          },
          enableBearerInterceptor: true
        }
      )
      .then((connected) => {
        keycloakService.isLoggedIn().then(isLogged => {
          keycloakService.updateToken().then((token) => {
            const header: HttpHeaders = new HttpHeaders();
            keycloakService.addTokenToHeader(header).subscribe(headerResult => {
              // On va chercher notre access token
              this.httpClient.get(
                environment.keycloakBroker,
                {headers: headerResult}).pipe(map(
                (json: Object) => AccessToken.fromJson(json)
              )).subscribe(access_token_result => {
                if (access_token_result) {
                  microsoftGraph.init(access_token_result);
                  this.authenticationService.login(access_token_result.access_token);
                }
              });
            });
          });
        });
        appRef.bootstrap(AppComponent);
      })
      .catch(error => console.error('[ngDoBootstrap] init Keycloak failed', error));
  }
}
